<div
  class="fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-white via-cream-100 to-stone-100 dark:from-[#0f172a] dark:via-[#0d1425] dark:to-[#0a101e] px-6"
>
  <!-- Blob 1: terracotta -->
  <div
    class="absolute blob-1 w-80 h-80 bg-primary/40 dark:bg-primary/25 blur-[80px]"
  ></div>

  <!-- Blob 2: peach -->
  <div
    class="absolute blob-2 w-72 h-72 bg-peach/45 dark:bg-peach/20 blur-[70px]"
  ></div>

  <!-- Content -->
  <div class="relative z-10 flex flex-col items-center gap-6 text-center">
    <om-brand-logo [heightClass]="logoHeightClass()" />
    <p
      class="text-base font-bold text-slate-500 dark:text-slate-300 font-serif italic tracking-wide"
    >
      {{ resolvedMessage() }}
    </p>
  </div>
</div>
